export default __webpack_public_path__ + "static/media/water_avoided.466df185.svg";